import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { IServiceList, IServicePost, ServicesPageService } from '../services-page.service';
import * as _ from 'lodash'
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';

@Component({
  selector: 'app-service-generic-post',
  templateUrl: './service-generic-post.component.html',
  styleUrls: ['./service-generic-post.component.css']
})
export class ServiceGenericPostComponent implements OnInit, OnDestroy {
  public currTitle: string;
  public currService: IServiceList;
  public fullServiceList: IServiceList[];
  private routerSub: any;

  constructor(private serviceServices: ServicesPageService, private router: Router,
    private location: Location) { }

  ngOnInit(): void {
    this.fullServiceList = this.serviceServices.getServiceList();
    this.updateCurrentSelection(this.location.path());
    this.routerSub = this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      this.updateCurrentSelection(evt.url)
    });
  }

  ngOnDestroy(): void {
    if (this.routerSub !== undefined) {
      this.routerSub.unsubscribe();
    }
  }

  updateCurrentSelection(location) {
    let currentEndpoint = location.slice(location.lastIndexOf('/')+1, location.length);
    this.currTitle = this.fullServiceList[this.fullServiceList.findIndex(x => x.link === currentEndpoint)].title;
  }
}
